import React from "react";
import PropTypes from "prop-types";

import { Form } from "..";

export function FormMultiselectDropdown({
  id,
  name,
  description,
  options,
  value,
  required,
  errorMessage,
  disabled,
}) {
  return (
    <Form.Dropdown
      multiple
      data-test="form-multiselect-dropdown"
      disableCloseOnSelect
      filterSelectedOptions
      name={id}
      label={name}
      description={description}
      initialValue={value}
      placeholder="Select at least one value"
      options={options}
      required={required}
      errorMessage={errorMessage}
      disabled={disabled}
    />
  );
}

FormMultiselectDropdown.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  options: PropTypes.array.isRequired,
  description: PropTypes.string,
  value: PropTypes.array,
  required: PropTypes.bool,
  errorMessage: PropTypes.string,
  disabled: PropTypes.bool,
};

FormMultiselectDropdown.defaultProps = {
  description: "",
  value: [],
  required: true,
  errorMessage: "Please select at least one value",
  disabled: false,
};

export default FormMultiselectDropdown;
